import { render, staticRenderFns } from "./salePayments.vue?vue&type=template&id=7c970e6e&"
import script from "./salePayments.vue?vue&type=script&lang=js&"
export * from "./salePayments.vue?vue&type=script&lang=js&"
import style0 from "./salePayments.vue?vue&type=style&index=0&id=7c970e6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports